export const brandData = {
  title: '关于NOPAY钱包',
  subtitle: 'ABOUT US',
  introImage: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20corporate%20headquarters%20building%20at%20sunset%2C%20dark%20glass%20architecture%2C%20golden%20warm%20lighting%2C%20premium%20corporate%20photography%2C%20professional%20atmosphere&width=800&height=500&seq=nopay-about-intro&orientation=landscape',
  introText: 'NOPAY钱包是一家专注于数字化娱乐领域的全球领先平台，成立于2018年。我们坚持秉持"用户体验至上、技术引领"的核心理念，致力于为全球用户构建安全公平、稳健高效的数字化娱乐殿堂。',
  sections: [
    {
      title: '品牌故事',
      content: 'NOPAY钱包诞生于数字化浪潮之中，创始团队来自全球顶级互联网企业和金融机构。我们深知数字时代的机遇与挑战，立志打造一个让每位用户都能安心使用、畅享娱乐的数字化平台。',
    },
    {
      title: '核心价值观',
      content: '安全第一：金融级防护体系，守护每一位用户的数字资产。用户至上：24/7全时客服，每一次服务都力求完美。创新引领：持续技术投入，引领行业发展方向。诚信为本：合规运营，透明公正。',
    },
    {
      title: '全球布局',
      content: 'NOPAY钱包已在全球30多个国家和地区开展业务，服务超过500万活跃用户。我们拥有国际化的专业团队，致力于为不同地区的用户提供本地化的优质服务。',
    },
  ],
  partnersImage: 'https://readdy.ai/api/search-image?query=Modern%20international%20business%20partnership%20concept%2C%20dark%20elegant%20corporate%20setting%2C%20golden%20globe%20and%20connection%20lines%2C%20premium%20photography%2C%20warm%20lighting&width=1800&height=600&seq=nopay-about-partners&orientation=landscape',
  milestones: [
    { year: '2018', event: 'NOPAY钱包正式成立，推出首款数字钱包产品' },
    { year: '2019', event: '获国际顶级风投A轮融资，用户突破50万' },
    { year: '2020', event: '完成全球化布局，业务覆盖15个国家和地区' },
    { year: '2021', event: '获得金融级安全认证，用户突破200万' },
    { year: '2022', event: '推出VIP尊享服务，获最佳创新产品奖' },
    { year: '2023', event: '用户突破400万，获行业最佳数字平台提名' },
    { year: '2024', event: '安全系统全面升级，引入AI智能风控' },
    { year: '2025', event: '获年度最佳数字平台奖，品牌全面焕新' },
    { year: '2026', event: '成为FIFA世界杯官方合作伙伴，开启新纪元' },
  ],
  contactInfo: {
    address: '北京市朝阳区建国路88号SOHO现代城A座28层',
    phone: '400-888-6688',
    email: 'hello@dajiang03.cn',
    businessHours: '周一至周日 00:00-24:00（全年无休）',
  },
  faqData: [
    {
      question: 'NOPAY钱包是什么？',
      answer: 'NOPAY钱包是一款安全、便捷的数字化娱乐平台，提供数字资产管理、交易服务及世界杯主题活动等功能。我们坚持以用户为中心，为用户提供极致的数字化体验。',
    },
    {
      question: '如何保障我的账户安全？',
      answer: '我们采用银行级256位SSL加密、多重身份验证、冷热钱包分离存储、AI智能风控等多项行业领先的安全技术，全方位保护您的账户和资产安全。',
    },
    {
      question: 'NOPAY钱包支持哪些功能？',
      answer: 'NOPAY钱包支持数字资产管理、快速充提、交易记录查询、世界杯活动参与、VIP专属服务和24/7在线客服等功能。',
    },
    {
      question: '如何联系客服？',
      answer: '您可以通过以下方式联系我们：在线客服（官网右下角）、官方热线400-888-6688、hello@dajiang03.cn。我们的客服团队7×24小时全天候为您服务。',
    },
    {
      question: 'NOPAY钱包是否合规运营？',
      answer: '是的，NOPAY钱包持有国际权威运营牌照，严格遵守所在地法律法规，并已通过ISO 27001和SOC 2 Type II等国际安全认证。',
    },
  ],
  teamData: [
    {
      name: '张明远',
      role: '创始人 & CEO',
      image: 'https://readdy.ai/api/search-image?query=Confident%20Chinese%20business%20leader%20portrait%2C%20dark%20suit%2C%20warm%20professional%20lighting%2C%20neutral%20cream%20background%2C%20executive%20headshot&width=400&height=400&seq=nopay-team-01&orientation=squarish',
      description: '前全球顶级金融机构高管，拥有20年金融科技行业经验',
    },
    {
      name: '李思琪',
      role: '联合创始人 & CTO',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20tech%20leader%20portrait%2C%20dark%20blazer%2C%20warm%20lighting%2C%20neutral%20background%2C%20confident%20executive%20headshot&width=400&height=400&seq=nopay-team-02&orientation=squarish',
      description: '前硅谷顶尖科技公司技术总监，分布式系统与安全领域专家',
    },
    {
      name: '王浩然',
      role: '首席运营官 COO',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20executive%20portrait%2C%20dark%20suit%2C%20warm%20lighting%2C%20neutral%20cream%20background%2C%20corporate%20headshot&width=400&height=400&seq=nopay-team-03&orientation=squarish',
      description: '拥有丰富的跨国企业运营管理经验，曾主导多个亿级用户平台',
    },
  ],
};